import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import { createSlot } from "../../services/slots/slots";

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class NewSlot extends Component {
  constructor(props) {
    super(props);
    this.createSlot = this.createSlot.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      sizes: [
        {
          value: "small",
          label: "Pequeno",
        },
        {
          value: "medium",
          label: "Médio",
        },
        {
          value: "large",
          label: "Grande",
        },
        {
          value: "extra-large",
          label: "Extra Grande",
        },
      ],
      categories: [
        {
          value: false,
          label: "sem restrição",
        },
        {
          value: true,
          label: "deficiente físico",
        },
        {
          value: "control",
          label: "painel de controle",
        },
      ],
      size: null,
      slot: "",
      label: "",
      waiting: false,
      error: false,
      category: "",
      deviceCondition: null,
      pne: false,
    };
  }

  createSlot = (lockerId, data) => {
    createSlot(lockerId, data, (dataR) => {
      this.setState({ waiting: false });
      this.props.onChange(false);
      dataR
        ? this.props.setNotification(
            "Nova Porta criada com sucesso!",
            "success"
          )
        : this.props.setNotification("Falha ao criar Nova Porta!", "danger");
    });
  };

  handleChange = (event) => {
    let e = event.target.id ? event.target.id : event.target.name;
    switch (e) {
      case "slot":
        this.setState({ slot: event.target.value });
        break;
      case "label":
        this.setState({ label: event.target.value });
        break;
      case "category":
        if (event.target.value === "control") {
          this.setState({ deviceCondition: event.target.value });
        } else {
          this.setState({ pne: event.target.value });
        }
        break;
      default:
        this.setState({ size: event.target.value });
        break;
    }
  };

  handleClickOpen = () => {
    this.props.onChange(true);
  };

  handleCreate = () => {
    let { size, slot, label, deviceCondition, pne} = this.state;
    let { lockerId } = this.props;

    if (lockerId && size && slot) {
      this.setState({ waiting: true, error: false });
      deviceCondition = deviceCondition ? deviceCondition : 'Created';
      let data = {
        name: slot, 
        status: 'available',
        size, 
        label,
        deviceCondition,
        pne
      };
      this.createSlot(lockerId, data);
    } else {
      this.setState({ error: true });
    }
  };

  handleClose = () => {
    this.props.onChange(false);
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          className={this.state.waiting ? classes.dialog : null}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.waiting ? "Criando Porta" : "Criar Nova Porta"}
          </DialogTitle>
          <DialogContent>
            {this.state.waiting ? (
              <div>
                <Circular />
              </div>
            ) : (
              <form className={classes.root} noValidate autoComplete="off">
                <div className="align-fields">
                  <FormControl
                    className={
                      this.state.error && !this.state.slot
                        ? classes.red
                        : classes.green
                    }
                  >
                    <InputLabel htmlFor="slot">Nome da Porta</InputLabel>
                    <Input
                      error={
                        this.state.error && !this.state.slot ? true : false
                      }
                      value={this.state.slot}
                      onChange={this.handleChange}
                      id="slot"
                    />
                  </FormControl>
                  <FormControl
                    className={
                      this.state.error && !this.state.label
                        ? classes.red
                        : classes.green
                    }
                  >
                    <InputLabel htmlFor="slot">Label</InputLabel>
                    <Input
                      error={
                        this.state.error && !this.state.label ? true : false
                      }
                      value={this.state.label}
                      onChange={this.handleChange}
                      id="label"
                    />
                  </FormControl>
                  <TextField
                    className={
                      this.state.error && !this.state.size
                        ? classes.red
                        : classes.green
                    }
                    id="outlined-size-input"
                    error={this.state.error && !this.state.size ? true : false}
                    select
                    label="Tamanho"
                    value={this.state.size}
                    onChange={this.handleChange}
                  >
                    {this.state.sizes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    className={
                      this.state.error && !this.state.categories
                        ? classes.red
                        : classes.green
                    }
                    id="outlined-size-input"
                    error={
                      this.state.error && !this.state.categories ? true : false
                    }
                    select
                    name="category"
                    label="Categoria"
                    value={(this.state.deviceCondition === 'control') ? 'control' : this.state.pne}
                    onChange={this.handleChange}
                  >
                    {this.state.categories.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </form>
            )}
          </DialogContent>
          <DialogActions>
            {this.state.waiting ? null : (
              <div>
                <Button onClick={this.handleClose} color="default">
                  Cancelar
                </Button>
                <Button onClick={this.handleCreate} color="primary" autoFocus>
                  Criar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(useStyles)(NewSlot);
